<template>
    <button type="button" class="custom-theme-card pa-3 h-full" role="article" @click="$emit('select')">
        <div class="custom-content">
            <div class="custom-icon-wrap">
                <v-icon color="primary" size="22">mdi-pencil-plus-outline</v-icon>
            </div>
            <div class="custom-text">
                <p class="custom-title text-violet ma-0">Quero sugerir meu próprio tema</p>
                <p class="custom-subtitle text-muted ma-0">Digite o tema específico que você quer abordar</p>
            </div>
        </div>
    </button>
</template>

<script>
export default {
    name: 'ArtigosCustomThemeCard',
}
</script>

<style scoped>
.custom-theme-card {
    position: relative;
    display: block;
    width: 100%;
    text-align: left;
    border: 1px dashed rgba(112, 42, 225, 0.55);
    background: var(--glass-panel-bg);
    -webkit-backdrop-filter: blur(16px);
    backdrop-filter: blur(16px);
    border-radius: var(--radius-md);
    transition: transform 220ms ease, box-shadow 220ms ease, border-color 220ms ease, background 220ms ease;
    cursor: pointer;
    box-shadow: var(--shadow-soft);
    will-change: transform, box-shadow;
    font-family: inherit;
}

.custom-theme-card:hover {
    transform: translateY(-3px);
    border-color: rgba(112, 42, 225, 0.9);
    box-shadow: var(--shadow-glass-hover), 0 0 0 1px rgba(112, 42, 225, 0.3);
}

.custom-content {
    display: flex;
    align-items: center;
    gap: 12px;
}

.custom-icon-wrap {
    flex: 0 0 auto;
    width: 38px;
    height: 38px;
    border-radius: var(--radius-sm);
    background: rgba(112, 42, 225, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
}

.custom-text {
    min-width: 0;
}

.custom-title {
    font-size: 14px;
    line-height: 1.35;
    font-weight: 600;
}

.custom-subtitle {
    font-size: 12px;
    line-height: 1.35;
    margin-top: 2px !important;
}
</style>
